import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ProductCard from '../../components/ProductCard';
import { useCart } from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';
import { getApiUrl } from '../../config/api';

const Search = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const query = params.get('q') || '';
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { addToCart } = useCart();
  const { isWishlisted, toggleWishlist } = useWishlist();
  const [showAddedToCart, setShowAddedToCart] = useState(null);

  useEffect(() => {
    if (query) {
      setLoading(true);
      setError(null);
      fetch(getApiUrl(`/api/products/search?q=${encodeURIComponent(query)}`))
        .then(res => {
          if (!res.ok) throw new Error('Failed to fetch search results');
          return res.json();
        })
        .then(data => {
          setResults(Array.isArray(data) ? data : []);
          setLoading(false);
        })
        .catch(err => {
          setError(err.message);
          setLoading(false);
        });
    } else {
      setResults([]);
    }
  }, [query]);

  const handleAddToCart = (product) => {
    addToCart(product, 1, 'M', 'Default');
    setShowAddedToCart(product._id);
    setTimeout(() => setShowAddedToCart(null), 2000);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h2 className="text-2xl font-bold mb-6 text-gray-900">Search Results for "{query}"</h2>
      {loading ? (
        <div className="text-center py-12">Loading...</div>
      ) : error ? (
        <div className="text-center py-12 text-red-600">{error}</div>
      ) : results.length === 0 && query.trim() ? (
        <div className="text-center py-12 text-gray-500">No products found</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {results.map((product) => (
            <ProductCard
              key={product._id}
              product={product}
              onAddToCart={() => handleAddToCart(product)}
              isWishlisted={isWishlisted}
              toggleWishlist={toggleWishlist}
              showAddedToCart={showAddedToCart === product._id}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Search; 